// extracted by mini-css-extract-plugin
export var backimage = "main-slider-module--backimage--z0KW-";
export var backvideo = "main-slider-module--backvideo--IRVAL";
export var mainslider = "main-slider-module--mainslider--ScX9+";
export var mainslidercontainer = "main-slider-module--mainslidercontainer--HI6hE";
export var mainvideoslidercontainer = "main-slider-module--mainvideoslidercontainer--dCi2A";
export var sliderbgdarktransparent = "main-slider-module--sliderbgdarktransparent--NUqS3";
export var slidercontainer = "main-slider-module--slidercontainer--2-4sg";
export var stretch = "main-slider-module--stretch--6Il4+";
export var videoslidercontainer = "main-slider-module--videoslidercontainer--CJM8u";